import { BrandEntity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCreateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCreateResponseDTO.validationSchema(),
    BrandEntity
  );

  constructor(readonly data: RoomBrandCreateResponse) {
    JsonSchemaValidator.assert(RoomBrandCreateResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["brand"],
      properties: {
        brand: {
          instanceof: BrandEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCreateResponse {
  brand: BrandEntity;
}
